{
	"name": "@cloudillo/quillo-app",
	"version": "0.8.20",
	"private": true,
	"description": "Quillo text editor app",
	"type": "module",
	"main": "src/index.js",
	"scripts": {
		"l-scan": "i18next-scanner --config src/i18n/scanner.config.cjs",
		"ts": "tsgo --noEmit",
		"ts-test": "tsgo --noEmit -p tsconfig.test.json",
		"ts-watch": "tsgo --noEmit --watch",
		"build": "pnpm run ts && cross-env NODE_ENV=production node esbuild.config.js",
		"watch": "node esbuild.config.js --watch",
		"test": "cross-env NODE_OPTIONS=\"--experimental-vm-modules\" jest",
		"test:watch": "cross-env NODE_OPTIONS=\"--experimental-vm-modules\" jest --watch",
		"test:coverage": "cross-env NODE_OPTIONS=\"--experimental-vm-modules\" jest --coverage",
		"clean": "rimraf .cache dist/assets-*"
	},
	"author": "Szilárd Hajba <szilu@cloudillo.org",
	"license": "LGPL-3.0-or-later",
	"devDependencies": {
		"@cloudillo/core": "workspace:^",
		"@cloudillo/crdt": "workspace:^",
		"@cloudillo/fonts": "workspace:^",
		"@cloudillo/react": "workspace:^",
		"@enzedonline/quill-blot-formatter2": "^3.2.0",
		"@symbion/opalui": "^0.16.0",
		"@types/jest": "^30.0.0",
		"@types/react": "^19.3.0",
		"@types/react-dom": "^19.3.0",
		"cross-env": "^10.1.0",
		"esbuild": "^0.28.2",
		"i18next": "^26.5.2",
		"i18next-scanner": "^4.6.0",
		"i18next-scanner-typescript": "^1.2.1",
		"jest": "^30.5.2",
		"lucide": "^1.59.0",
		"quill": "^2.0.3",
		"quill-cursors": "^6.0.0",
		"quill-delta": "^5.1.0",
		"quill-table-better": "^1.2.3",
		"react": "19.3.1",
		"react-dom": "19.3.1",
		"react-icons": "^5.7.0",
		"rimraf": "^6.1.3",
		"ts-jest": "^29.4.15",
		"tslib": "^2.8.1",
		"typescript": "npm:@typescript/typescript6@^6.0.2",
		"y-indexeddb": "^9.0.12",
		"y-protocols": "^1.0.7",
		"y-quill": "^1.0.0",
		"y-websocket": "^3.1.0",
		"yjs": "^13.6.33"
	},
	"dependencies": {
		"marked": "^18.1.1"
	}
}
